import {
  isCCNumberValidAmex,
  isCCNumberMasked,
  isCCNumberValid,
} from './ccNumberValidation';

const isCvcValid = (value = '', { isAmex, isMasked }) => {
  const isThreeNumbers = value.match(/^[0-9]{3}$/);
  const isFourNumbers = value.match(/^[0-9]{4}$/);

  if (isMasked) {
    return isThreeNumbers || isFourNumbers;
  }
  if (isAmex) {
    return isFourNumbers;
  }
  return isThreeNumbers;
};

const validateCcNumber = creditCardNumber => {
  if (!creditCardNumber) {
    return { creditCardNumber: '*Required' };
  }

  if (!isCCNumberValid(creditCardNumber)) {
    return { creditCardNumber: '*Invalid card number' };
  }

  return {};
};

const validateCvc = (cvc, { isAmex, isMasked }) => {
  if (!cvc) {
    return { ccSecurityCode: '*Required' };
  }

  if (!isCvcValid(cvc, { isAmex, isMasked })) {
    return { ccSecurityCode: '*Invalid security code' };
  }

  return {};
};

const ccNumAndCvcValidation = (creditCardNumber, cvc) => ({
  ...validateCcNumber(creditCardNumber),
  ...validateCvc(cvc, {
    isAmex: isCCNumberValidAmex(creditCardNumber),
    isMasked: isCCNumberMasked(creditCardNumber),
  }),
});

export default ccNumAndCvcValidation;



// WEBPACK FOOTER //
// ./src/components/Forms/Validations/ccNumAndCvcValidation.js